/* eslint-disable no-param-reassign */

import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Button,
  Grid,
  Typography,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  Stack,
  Card,
  Pagination,
  CardContent,
} from '@mui/material';
import {
  ArrowUpward, Download,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import OrderList from 'src/components/dashboard/OrderList';
import download from 'downloadjs';
import { filterOrderCsv, filterOrders } from '../store/orders/orders.action';

function Orders(...props) {
  const orderStatuses = ['placed', 'confirmed', 'in_transit', 'delivered', 'canceled'];
  const paymentMethods = ['Credit', 'Lipa Na Mpesa', 'Cash on delivery'];

  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [filterPayload, setFilterPayload] = useState({});
  const [downloadingCsv, setDownloadingCsv] = useState(false);
  const [page, setPage] = useState(1);

  const pageSize = 15;

  const dispatch = useDispatch();
  const orderState = useSelector((state) => state.orderReducer);
  const { orders } = orderState;
  const userState = useSelector((state) => state.userReducer);
  const { counts } = userState;

  const pageCount = Math.floor(counts.orderCount / pageSize) + 1;

  useEffect(() => {
    dispatch(filterOrders(filterPayload, { page, pageSize }));
  }, [dispatch, filterPayload, page]);

  const dowloadOrdersCsv = async () => {
    setDownloadingCsv(true);
    try {
      const response = await filterOrderCsv(filterPayload);
      if (response) {
        download(response, 'orders-data.csv');
        setDownloadingCsv(false);
      }
    } catch (error) {
      setDownloadingCsv(false);
      console.log(error);
    }
  };

  const testHandlePageChange = (event, newPage) => {
    setPage(newPage);
    dispatch(filterOrders(filterPayload, { page: newPage, pageSize }));
  };

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    setFilterPayload({ ...filterPayload, orderStatus: status });
    dispatch(filterOrders(filterPayload, { page, pageSize }));
  };

  const handlePaymentChange = (method) => {
    setSelectedPaymentMethod(method);
    setFilterPayload({ ...filterPayload, paymentMethod: method });
    dispatch(filterOrders(filterPayload, { page, pageSize }));
  };

  return (
    <>
      <Helmet>
        <title>Orders | Rewot dashboard</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
        }}
      >
        <Box>
          {/* <CustomerListToolbar /> */}

          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 1 }}>FILTERS</Typography>

              <Stack direction="row" spacing={3} sx={{ height: 56 }} justifyContent="space-between">
                <Box>
                  <FormControl sx={{ minWidth: 200 }}>
                    <InputLabel id="order-status-label">Order Status</InputLabel>
                    <Select
                      labelId="order-status-label"
                      id="order-status-select"
                      value={selectedStatus}
                      onChange={(event) => handleStatusChange(event.target.value)}
                      label="Order Status"
                    >
                      <MenuItem value="">
                        <em>All</em>
                      </MenuItem>

                      {orderStatuses.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                        >
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ minWidth: 200 }}>
                    <InputLabel id="payment_method-label">Payment Method</InputLabel>
                    <Select
                      labelId="payment_method-label"
                      id="payment_method-select"
                      value={selectedPaymentMethod}
                      onChange={(event) => handlePaymentChange(event.target.value)}
                      label="Payment method"
                    >
                      <MenuItem value="">
                        <em>All</em>
                      </MenuItem>

                      {paymentMethods.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                        >
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                <Button
                  variant="contained"
                  sx={{ marginRight: 0, color: 'white', height: 40 }}
                  startIcon={<Download />}
                  disabled={downloadingCsv}
                  onClick={dowloadOrdersCsv}
                >
                  EXPORT
                </Button>

              </Stack>
            </CardContent>
          </Card>

          <Box sx={{ pt: 3 }}>
            <OrderList orders={orders} title="Orders" paginate />
          </Box>

          <Grid
            container
            spacing={1}
            direction="row"
            justifyContent="flex-end"
            sx={{ mt: 4 }}
          >
            <Pagination
              count={pageCount}
              color="primary"
              defaultPage={1}
              showFirstButton
              showLastButton
              onChange={testHandlePageChange}
            />

          </Grid>
        </Box>
      </Box>
    </>
  );
}
export default Orders;
